import { BURSTS } from './bursts';
import { type EventOf, type Fx, PRONE_HEIGHT } from './context';
import { isDog } from '../../../sim/enemies/specials/kinds';

/* The small stuff: bullet strikes, blood, and the puff of a thrown grenade leaving the hand. */

const HIT_HEIGHT = 1.2;
/** ROUND8: a dog stands 0.6 m at the shoulder - a man's 1.2 m puff floated over its back. */
const DOG_HIT_HEIGHT = 0.45;

/** A few crumbs of the ground thrown up, and one dust puff. `y` is the strike's height above ground. */
export function impact(fx: Fx, e: EventOf<'impact'>): void {
  const ground = fx.groundY(e.x, e.z);
  const y = ground + Math.max(0.05, e.y);
  fx.particles.burst(BURSTS.impact, fx.set.impactDebris, 3 + fx.rng.int(3), e.x, y, e.z, ground, 1);
  fx.particles.puff(fx.set.b.dust, e.x, y + 0.1, e.z, 0.28, 0.4, 0.5, 0);
}

export function throwPuff(fx: Fx, e: EventOf<'throw'>): void {
  fx.particles.puff(fx.set.b.dust, e.x, fx.groundY(e.x, e.z) + 1.3, e.z, 0.22, 0.3, 0.4, 0);
}

function bleed(fx: Fx, x: number, z: number, height: number, count: number): void {
  const ground = fx.groundY(x, z);
  fx.particles.burst(BURSTS.blood, fx.set.bloodDebris, count, x, ground + height, z, ground, 1);
}

/** The event names nobody: it is always the ranger, wherever the last world put him. */
export function rangerHit(fx: Fx): void {
  const ranger = fx.world?.ranger;
  if (ranger) bleed(fx, ranger.x, ranger.z, ranger.stance === 'crawl' ? PRONE_HEIGHT : HIT_HEIGHT, 3);
}

/** The event carries an id; the victim is looked up in the last world passed to `update`. */
export function enemyHit(fx: Fx, e: EventOf<'enemyHit'>): void {
  const enemy = fx.world?.enemies.find((o) => o.id === e.id);
  if (enemy) bleed(fx, enemy.x, enemy.z, isDog(enemy.kind) ? DOG_HIT_HEIGHT : HIT_HEIGHT, e.killed ? 5 : 3);
}
